export const SURFACE_EDITOR_COLOR_MODES = {
  light: 'light',
  dark: 'dark'
};
export const SURFACE_EDITOR_MIN_SCALE = 0.1;
export const SURFACE_EDITOR_MAX_SCALE = 3;
export const SURFACE_EDITOR_SCALE_STEP = 0.01;
export const SURFACE_EDITOR_SCALE_MULTIPLIER = 1.2;
export const SURFACE_EDITOR_DRAG_HANDLE = {
  all: 'all',
  topLeft: 'tl',
  topRight: 'tr',
  bottomLeft: 'bl',
  bottomRight: 'br',
  top: 't',
  left: 'l',
  bottom: 'b',
  right: 'r',
  rotate: 'rotate'
};

export const SURFACE_EDITOR_ELEMENT_TYPE = {
  image: 'image_box',
  text: 'text_box',
  shape: 'shape'
};

export const SURFACE_EDITOR_SHAPES = {
  rectangle: 'rectangle',
  circle: 'circle'
};

export const SURFACE_EDITOR_REORDER_ACTIONS = {
  forward: 'forward',
  backward: 'backward',
  front: 'front',
  back: 'back'
};

export const SURFACE_EDITOR_STROKE_STYLES = {
  none: 'none',
  solid: 'solid',
  dashed: 'dashed',
  dotted: 'dotted'
};

export const SURFACE_EDITOR_MAX_STROKE_WIDTH = 30;

export const SURFACE_EDITOR_MIN_ELEMENT_DIMENSION = 10;

export const SURFACE_EDITOR_FILL_TYPES = {
  solid: 'solid',
  linearGradient: 'linear-gradient',
  imagePattern: 'image-pattern'
};

export const SURFACE_EDITOR_COLOR_TYPES = {
  solid: {
    key: 'solid',
    label: 'Solid'
  },
  imagePattern: {
    key: 'image-pattern',
    label: 'Image Pattern'
  },
  linearGradient: {
    key: 'linear-gradient',
    label: 'Gradient'
  }
};

export const SURFACE_EDITOR_COLOR_PANEL_MODES = {
  shapeFill: 'shapeFill',
  bgFill: 'bgFill',
  shapeStroke: 'shapeStroke',
  text: 'text'
};

export const SURFACE_EDITOR_EDITABLE_ELEMENTS = [
  SURFACE_EDITOR_ELEMENT_TYPE.image,
  SURFACE_EDITOR_ELEMENT_TYPE.text,
];

export const SURFACE_EDITOR_FREEFORM_RESIZE_ELEMENT_TYPES = [
  SURFACE_EDITOR_ELEMENT_TYPE.shape,
];

export const SURFACE_EDITOR_TEMPLATE_TYPES = {
  user: 'user',
  system: 'system'
};

export const SURFACE_EDITOR_IMAGE_EXPORT_API = '/app/api/proxy-asset';

export const SURFACE_EDITOR_LINE_SPACING_MIN = 1;
export const SURFACE_EDITOR_LINE_SPACING_MAX = 3;
export const SURFACE_EDITOR_LINE_SPACING_STEP = 0.1;
export const SURFACE_EDITOR_LETTER_SPACING_MIN = -400;
export const SURFACE_EDITOR_LETTER_SPACING_MAX = 800;
export const SURFACE_EDITOR_LETTER_SPACING_STEP = 1;

export const SURFACE_EDITOR_ROTATION_SNAP_INTERVAL  = 45;
export const SURFACE_EDITOR_ROTATION_SNAP_THRESHOLD  = 2;

